import { appService } from "site/services/app.service";
import {
  getSessionToken,
  hasBookContentKeyInSession,
  refreshAuthSession,
} from "site/services/auth-session.service";
import { subscriptionApiBaseUrl } from "site/services/xq-api-base-url";
export { subscriptionApiBaseUrl };

export async function tryRefreshBookAccessAfterPayment(bookId: string): Promise<boolean> {
  const bid = `${bookId}`;
  if (!bid || !subscriptionApiBaseUrl() || !getSessionToken()) {
    return false;
  }
  try {
    await refreshAuthSession();
  } catch {
    return false;
  }
  if (!hasBookContentKeyInSession(bid)) {
    return false;
  }
  appService.notifySubscriptionAccessChanged();
  return true;
}
